import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "../components/Toast/toast.ts";

const AuthContext = createContext();

export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(() => {
        const storedAuth = localStorage.getItem("auth");
        return storedAuth ? JSON.parse(storedAuth) : false;
    });

    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const storedToken = localStorage.getItem("token");

        const fetchUserData = async () => {
            try {
                if (storedToken) {
                    const userResponse = await axios.get(
                        `${process.env.REACT_APP_API_URL}/api/cust-portal/customer/user-details`,
                        {
                            headers: {
                                Authorization: `Bearer ${storedToken}`,
                            },
                        }
                    );
                    setUserData(userResponse?.data);
                    setAuth(true);
                    localStorage.setItem("auth", JSON.stringify(true));
                }
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    const { message } = error.response.data;
                    if (message === "Token Expired") {
                        toast.error("Your session has expired. Please log in again.");
                        localStorage.clear();
                        setAuth(false);
                        navigate("/login");
                        return;
                    }
                }
                toast.error(error?.response?.data?.message || error?.message || "An error occurred. Please try again.");
                setAuth(false);
                localStorage.setItem("auth", JSON.stringify(false));
                navigate("/login");
            } finally {
                setIsLoading(false);
            }
        };

        if (storedToken) {
            fetchUserData();
        } else {
            setIsLoading(false);
        }
        //eslint-disable-next-line
    }, []);

    return (
        <AuthContext.Provider value={{ auth, setAuth, userData, setUserData, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
};
